// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthorsController from "./authors_controller"
application.register("authors", AuthorsController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import BookClubForumController from "./book_club_forum_controller"
application.register("book-club-forum", BookClubForumController)

import BookClubMeetingComboboxController from "./book_club_meeting_combobox_controller"
application.register("book-club-meeting-combobox", BookClubMeetingComboboxController)

import BookClubMeetingController from "./book_club_meeting_controller"
application.register("book-club-meeting", BookClubMeetingController)

import BookClubMeetingFormController from "./book_club_meeting_form_controller"
application.register("book-club-meeting-form", BookClubMeetingFormController)

import BookClubMeetingHostComboboxController from "./book_club_meeting_host_combobox_controller"
application.register("book-club-meeting-host-combobox", BookClubMeetingHostComboboxController)

import BookClubMeetingHostFormController from "./book_club_meeting_host_form_controller"
application.register("book-club-meeting-host-form", BookClubMeetingHostFormController)

import BookClubMeetingHostSearchDropdownController from "./book_club_meeting_host_search_dropdown_controller"
application.register("book-club-meeting-host-search-dropdown", BookClubMeetingHostSearchDropdownController)

import BookClubMemberComboboxController from "./book_club_member_combobox_controller"
application.register("book-club-member-combobox", BookClubMemberComboboxController)

import BookClubMemberFormController from "./book_club_member_form_controller"
application.register("book-club-member-form", BookClubMemberFormController)

import BookClubMemberSearchDropdownController from "./book_club_member_search_dropdown_controller"
application.register("book-club-member-search-dropdown", BookClubMemberSearchDropdownController)

import BookClubsController from "./book_clubs_controller"
application.register("book-clubs", BookClubsController)

import BuddyReadsComboboxController from "./buddy_reads_combobox_controller"
application.register("buddy-reads-combobox", BuddyReadsComboboxController)

import BuddyReadsController from "./buddy_reads_controller"
application.register("buddy-reads", BuddyReadsController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import CompareStatsDropdownController from "./compare_stats_dropdown_controller"
application.register("compare-stats-dropdown", CompareStatsDropdownController)

import CoverZoomController from "./cover_zoom_controller"
application.register("cover-zoom", CoverZoomController)

import CustomStatsController from "./custom_stats_controller"
application.register("custom-stats", CustomStatsController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DrawTypeInfoController from "./draw_type_info_controller"
application.register("draw-type-info", DrawTypeInfoController)

import FavoritesComboboxController from "./favorites_combobox_controller"
application.register("favorites-combobox", FavoritesComboboxController)

import FavoritesFormController from "./favorites_form_controller"
application.register("favorites-form", FavoritesFormController)

import FavoritesSearchDropdownController from "./favorites_search_dropdown_controller"
application.register("favorites-search-dropdown", FavoritesSearchDropdownController)

import FormController from "./form_controller"
application.register("form", FormController)

import GiveawayPrizesController from "./giveaway_prizes_controller"
application.register("giveaway-prizes", GiveawayPrizesController)

import GiveawaysController from "./giveaways_controller"
application.register("giveaways", GiveawaysController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NativeTabsController from "./native_tabs_controller"
application.register("native-tabs", NativeTabsController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PagyInitializerController from "./pagy_initializer_controller"
application.register("pagy-initializer", PagyInitializerController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import ProfileActionsController from "./profile_actions_controller"
application.register("profile-actions", ProfileActionsController)

import PollOptionComboboxController from "./poll_option_combobox_controller"
application.register("poll-option-combobox", PollOptionComboboxController)

import PollOptionFormController from "./poll_option_form_controller"
application.register("poll-option-form", PollOptionFormController)

import PublishersController from "./publishers_controller"
application.register("publishers", PublishersController)

import ReadalongsComboboxController from "./readalongs_combobox_controller"
application.register("readalongs-combobox", ReadalongsComboboxController)

import ReadalongsController from "./readalongs_controller"
application.register("readalongs", ReadalongsController)

import ReadingChallengeBookPromptComboboxController from "./reading_challenge_book_prompt_combobox_controller"
application.register("reading-challenge-book-prompt-combobox", ReadingChallengeBookPromptComboboxController)

import ReadingChallengeBookPromptFormController from "./reading_challenge_book_prompt_form_controller"
application.register("reading-challenge-book-prompt-form", ReadingChallengeBookPromptFormController)

import ReadingChallengeBookPromptSearchDropdownController from "./reading_challenge_book_prompt_search_dropdown_controller"
application.register("reading-challenge-book-prompt-search-dropdown", ReadingChallengeBookPromptSearchDropdownController)

import ReadingChallengeBookPromptsController from "./reading_challenge_book_prompts_controller"
application.register("reading-challenge-book-prompts", ReadingChallengeBookPromptsController)

import ReadingChallengeComboboxController from "./reading_challenge_combobox_controller"
application.register("reading-challenge-combobox", ReadingChallengeComboboxController)

import ReadingChallengeEditFormController from "./reading_challenge_edit_form_controller"
application.register("reading-challenge-edit-form", ReadingChallengeEditFormController)

import ReadingChallengeFormController from "./reading_challenge_form_controller"
application.register("reading-challenge-form", ReadingChallengeFormController)

import ReadingChallengePromptComboboxController from "./reading_challenge_prompt_combobox_controller"
application.register("reading-challenge-prompt-combobox", ReadingChallengePromptComboboxController)

import ReadingChallengePromptFormController from "./reading_challenge_prompt_form_controller"
application.register("reading-challenge-prompt-form", ReadingChallengePromptFormController)

import ReadingChallengePromptSearchDropdownController from "./reading_challenge_prompt_search_dropdown_controller"
application.register("reading-challenge-prompt-search-dropdown", ReadingChallengePromptSearchDropdownController)

import ReadingChallengeSearchDropdownController from "./reading_challenge_search_dropdown_controller"
application.register("reading-challenge-search-dropdown", ReadingChallengeSearchDropdownController)

import ReadingChallengesController from "./reading_challenges_controller"
application.register("reading-challenges", ReadingChallengesController)

import ReadingPreferencesSurveyComboboxController from "./reading_preferences_survey_combobox_controller"
application.register("reading-preferences-survey-combobox", ReadingPreferencesSurveyComboboxController)

import ReadingPreferencesSurveyFormController from "./reading_preferences_survey_form_controller"
application.register("reading-preferences-survey-form", ReadingPreferencesSurveyFormController)

import ReadingPreferencesSurveySearchDropdownController from "./reading_preferences_survey_search_dropdown_controller"
application.register("reading-preferences-survey-search-dropdown", ReadingPreferencesSurveySearchDropdownController)

import RecommendationsComboboxController from "./recommendations_combobox_controller"
application.register("recommendations-combobox", RecommendationsComboboxController)

import RecommendationsController from "./recommendations_controller"
application.register("recommendations", RecommendationsController)

import RecommendationsFormController from "./recommendations_form_controller"
application.register("recommendations-form", RecommendationsFormController)

import RedrawWinnerController from "./redraw_winner_controller"
application.register("redraw-winner", RedrawWinnerController)

import RemoveBookController from "./remove_book_controller"
application.register("remove-book", RemoveBookController)

import ReviewsFilterMenuController from "./reviews_filter_menu_controller"
application.register("reviews-filter-menu", ReviewsFilterMenuController)

import Select2AuthorsController from "./select2_authors_controller"
application.register("select2-authors", Select2AuthorsController)

import Select2BuddyReadsController from "./select2_buddy_reads_controller"
application.register("select2-buddy-reads", Select2BuddyReadsController)

import Select2ContentWarningsController from "./select2_content_warnings_controller"
application.register("select2-content-warnings", Select2ContentWarningsController)

import Select2ContributorsController from "./select2_contributors_controller"
application.register("select2-contributors", Select2ContributorsController)

import Select2CountriesController from "./select2_countries_controller"
application.register("select2-countries", Select2CountriesController)

import Select2GenresController from "./select2_genres_controller"
application.register("select2-genres", Select2GenresController)

import Select2LanguagesController from "./select2_languages_controller"
application.register("select2-languages", Select2LanguagesController)

import Select2PronounsController from "./select2_pronouns_controller"
application.register("select2-pronouns", Select2PronounsController)

import Select2PublishersController from "./select2_publishers_controller"
application.register("select2-publishers", Select2PublishersController)

import Select2ReadingChallengesController from "./select2_reading_challenges_controller"
application.register("select2-reading-challenges", Select2ReadingChallengesController)

import Select2ReadingPreferencesController from "./select2_reading_preferences_controller"
application.register("select2-reading-preferences", Select2ReadingPreferencesController)

import Select2SeriesController from "./select2_series_controller"
application.register("select2-series", Select2SeriesController)

import Select2TagsController from "./select2_tags_controller"
application.register("select2-tags", Select2TagsController)

import SeriesController from "./series_controller"
application.register("series", SeriesController)

import SwipeToDeleteController from "./swipe_to_delete_controller"
application.register("swipe-to-delete", SwipeToDeleteController)

import WindowController from "./window_controller"
application.register("window", WindowController)

import WrapUpsController from "./wrap_ups_controller"
application.register("wrap-ups", WrapUpsController)
